import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import api from '../../api/client';

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [admin, setAdmin] = useState(null);
  const [categories, setCategories] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    api.get('/api/admin/me')
      .then((res) => setAdmin(res.data))
      .catch(() => navigate('/admin/login', { replace: true }));

    api.get('/api/admin/categories')
      .then((res) => setCategories(res.data))
      .catch(() => {});
  }, [navigate]);

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') setSidebarOpen(false); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  const handleLogout = async () => {
    await api.post('/logout');
    navigate('/admin/login', { replace: true });
  };

  const closeSidebar = () => setSidebarOpen(false);

  // 쿼리파라미터까지 비교하는 NavLink className 헬퍼
  const navLinkClass = (targetSearch, extraClass = '') => ({ isActive }) => {
    if (!isActive) return `nav-link${extraClass ? ' ' + extraClass : ''}`;
    const current = new URLSearchParams(location.search);
    const target  = new URLSearchParams(targetSearch);
    const targetEntries = [...target.entries()];
    if (targetEntries.length === 0 && [...current.entries()].length > 0) {
      return `nav-link${extraClass ? ' ' + extraClass : ''}`;
    }
    for (const [key, val] of targetEntries) {
      if (current.get(key) !== val) return `nav-link${extraClass ? ' ' + extraClass : ''}`;
    }
    return `nav-link active${extraClass ? ' ' + extraClass : ''}`;
  };

  const topLevel = categories.filter((c) => !c.parent);
  const children = (parentId) => categories.filter((c) => c.parent?.id === parentId);

  return (
    <div className="admin-layout">
      {sidebarOpen && (
        <div className="admin-overlay" onClick={closeSidebar} />
      )}

      <aside className={`admin-sidebar${sidebarOpen ? ' open' : ''}`}>
        <button className="sidebar-close-btn" onClick={closeSidebar} aria-label="사이드바 닫기">✕</button>

        <div className="admin-logo">
          <span>Hobbygom</span>
          <small>관리자</small>
        </div>

        <nav className="admin-nav">
          <div className="nav-section">
            <p className="nav-section-title">글 관리</p>
            <NavLink to="/admin/posts"                  className={navLinkClass('')}               end onClick={closeSidebar}>전체 글</NavLink>
            <NavLink to="/admin/posts?status=DRAFT"     className={navLinkClass('status=DRAFT')}       onClick={closeSidebar}>임시저장</NavLink>
            <NavLink to="/admin/posts?status=PUBLISHED" className={navLinkClass('status=PUBLISHED')}   onClick={closeSidebar}>발행됨</NavLink>
            <NavLink to="/admin/posts?status=ARCHIVED"  className={navLinkClass('status=ARCHIVED')}    onClick={closeSidebar}>보관됨</NavLink>
          </div>

          <div className="nav-section">
            <p className="nav-section-title">카테고리</p>
            <NavLink to="/admin/categories" className="nav-link" onClick={closeSidebar}>카테고리 관리</NavLink>
            {topLevel.map((cat) => (
              <div key={cat.id}>
                <NavLink
                  to={`/admin/posts?categoryId=${cat.id}`}
                  className={navLinkClass(`categoryId=${cat.id}`, 'nav-category')}
                  onClick={closeSidebar}
                >
                  {cat.name}
                </NavLink>
                {children(cat.id).map((child) => (
                  <NavLink
                    key={child.id}
                    to={`/admin/posts?categoryId=${child.id}`}
                    className={navLinkClass(`categoryId=${child.id}`, 'nav-category-child')}
                    onClick={closeSidebar}
                  >
                    {child.name}
                  </NavLink>
                ))}
              </div>
            ))}
          </div>

          <div className="nav-section">
            <p className="nav-section-title">시스템</p>
            <NavLink to="/admin/subscribers" className="nav-link" onClick={closeSidebar}>구독자 관리</NavLink>
            <NavLink to="/admin/settings" className="nav-link" onClick={closeSidebar}>설정</NavLink>
          </div>
        </nav>

        <div className="admin-footer">
          {admin && <span className="admin-username">{admin.username}</span>}
          <button onClick={handleLogout} className="btn-logout">로그아웃</button>
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-topbar">
          <button
            className="hamburger-btn"
            onClick={() => setSidebarOpen(true)}
            aria-label="메뉴 열기"
          >
            ☰
          </button>
          <NavLink to="/admin/posts/new" className="btn-primary">
            + 새 글 쓰기
          </NavLink>
        </div>
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
